export const categories = [
  {
    id: 'mingxing-bagua',
    name: '明星八卦',
    slug: 'mingxing-bagua',
    icon: 'ri-star-line',
    articleCount: 38,
  },
  {
    id: 'wanghong-dongtai',
    name: '网红动态',
    slug: 'wanghong-dongtai',
    icon: 'ri-live-line',
    articleCount: 25,
  },
  {
    id: 'remen-shijian',
    name: '热门事件',
    slug: 'remen-shijian',
    icon: 'ri-fire-line',
    articleCount: 42,
  },
  {
    id: 'yingshi-zongyi',
    name: '影视综艺',
    slug: 'yingshi-zongyi',
    icon: 'ri-film-line',
    articleCount: 31,
  },
  {
    id: 'shehui-redian',
    name: '社会热点',
    slug: 'shehui-redian',
    icon: 'ri-global-line',
    articleCount: 29,
  },
];